import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=2fa36ffb&scoped=true&"
import script from "./UserDialog.vue?vue&type=script&lang=js&"
export * from "./UserDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=2fa36ffb&lang=scss&scoped=true&"
import style1 from "./UserDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa36ffb",
  null
  
)

component.options.__file = "UserDialog.vue"
export default component.exports